var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 68,
    viewBox: "0 0 71 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8852CC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5 35C45.387 35 38 42.387 38 51.5S45.387 68 54.5 68 71 60.613 71 51.5A16.5 16.5 0 0 0 54.5 35zm0 30C47.044 65 41 58.956 41 51.5S47.044 38 54.5 38 68 44.044 68 51.5 61.956 65 54.5 65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.552 46.43l-6.942 7.056-2.161-2.201a1.418 1.418 0 0 0-1.017-.431c-.381 0-.747.155-1.016.43a1.477 1.477 0 0 0 0 2.056l3.192 3.236c.558.565 1.46.565 2.018 0l7.958-8.09a1.478 1.478 0 0 0-.007-2.062 1.414 1.414 0 0 0-2.025.007zM34.465 59.048H5.909a2.953 2.953 0 0 1-2.954-2.953V23.62h42.84a1.477 1.477 0 1 0 0-2.952H2.955V11.81a2.953 2.953 0 0 1 2.954-2.953h6.648v1.476a4.43 4.43 0 0 0 4.432 4.429h1.477a4.43 4.43 0 0 0 4.432-4.429V8.857h19.204v1.476a4.43 4.43 0 0 0 4.432 4.429h1.477a4.43 4.43 0 0 0 4.432-4.429V8.857h6.648a2.953 2.953 0 0 1 2.954 2.953v8.857h-6.618a1.477 1.477 0 1 0 0 2.952h6.618v8.769a1.477 1.477 0 0 0 2.955 0V11.81a5.907 5.907 0 0 0-5.91-5.905h-6.647V4.429A4.43 4.43 0 0 0 48.011 0h-1.477a4.43 4.43 0 0 0-4.432 4.429v1.476H22.898V4.429A4.43 4.43 0 0 0 18.466 0h-1.477a4.43 4.43 0 0 0-4.432 4.429v1.476H5.909A5.907 5.907 0 0 0 0 11.81v44.285A5.907 5.907 0 0 0 5.91 62h28.555a1.477 1.477 0 1 0 0-2.952zm10.592-54.62c0-.815.661-1.476 1.477-1.476h1.477c.816 0 1.478.661 1.478 1.477v5.904c0 .816-.662 1.477-1.478 1.477h-1.477c-.816 0-1.477-.661-1.477-1.477V4.43zm-29.546 0c0-.815.662-1.476 1.478-1.476h1.477c.816 0 1.477.661 1.477 1.477v5.904c0 .816-.661 1.477-1.477 1.477h-1.477c-.816 0-1.478-.661-1.478-1.477V4.43z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 33,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 49,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8a102946097d20fa7b79333999b2a163.svg";
export { ForwardRef as ReactComponent };